<div class="ctn-full-height">
  <dashboard [me]="authHelper.currentUserProfile$ | async"></dashboard>
</div>
